import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'antd';
import V2Form from '@/common/components/Form/V2Form';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import { useMethods } from '@lhb/hook';

/**
 * 拓店管理-超级侦探管理-选择模版弹框
 * @Description
 */
const FranchiseeSelectTemplate: React.FC<{
  templateData,
  setTemplateData,
  setFormDrawerData
}> = ({
  templateData,
  setTemplateData,
  setFormDrawerData
}) => {

  const visible = !!templateData?.open;
  const options = Array.isArray(templateData?.options) ? templateData?.options : [];

  /** 真正控制弹窗显示 */
  const [curVisible, setCurVisible] = useState(false);

  useEffect(() => {
    if (visible) {
      methods.init();
    } else {
      setCurVisible(false);
    }
  }, [visible]);

  const [form] = Form.useForm();

  const onCancel = () => {
    setTemplateData({
      ...templateData,
      open: false,
    });
  };

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
      setFormDrawerData({
        ...values,
        open: true,
      });
      onCancel();
    });
  };

  const methods = useMethods({

    init() {
      if (!Array.isArray(options)) {
        return;
      }
      // 如果只有一条数据，直接选中，否则展示弹窗
      if (options.length === 1) {
        methods.handleAutoSelectSingleItem();
      } else if (options.length > 1) {
        setCurVisible(true);
      }
    },

    /** 自动选择单条数据 */
    handleAutoSelectSingleItem() {
      if (Array.isArray(options) && options.length === 1) {
        setFormDrawerData({ templateId: options[0].value, open: true, });
        onCancel();
      }
    },

  });

  return (
    <Modal
      title='选择加盟商模板'
      open={curVisible}
      width={336}
      onOk={onSubmit}
      onCancel={onCancel}>
      <V2Form form={form}>
        <V2FormSelect
          label='选择模板'
          name='templateId'
          placeholder='请选择模板'
          rules={[{ required: true, message: '请选择模板' }]}
          options={options || []}
        />
      </V2Form>
    </Modal>
  );
};

export default FranchiseeSelectTemplate;
